import React from 'react';
import { connect } from 'react-redux';
import dataModel from '../../../models/DataModel';
import TextMap from '../../../helpers/TextMap';
import ReportHeader from '../../../containers/ManagerDashboard/ReportHeader';

import TeamPopup from '../../../components/TeamPopup';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import addIcon from '../../../assets/images/plus-circle.svg';
import TeamsTable from './TeamsTable';
import DirectoryTeamsSearchFilter from '../DirectoryTeamsSearchFilter';
import CollectionDataSource from '../../../dao/DataSource/CollectionDataSource';
import './Teams.scss';

export class Teams extends React.Component {
  constructor(props) {
    super(props);

    this.textMap = new TextMap();
    this.accent = this.props.currentCompany.accent_color ? this.props.currentCompany.accent_color : '#CD03A';

    this.handleAddButtonClicked = this.handleAddButtonClicked.bind(this);

    this.state = {
      teams: null,
      teamsCopy: null,
      filteredTeams: null,
      displayPopup: null,
      loadingTeams: true,
    };
    this.handleClosePopup = this.handleClosePopup.bind(this);
    this.handleTeamRetrieval = this.handleTeamRetrieval.bind(this);
    this.handleAddButtonClicked = this.handleAddButtonClicked.bind(this);
    this.createPopup = this.createPopup.bind(this);
    this.handleSelectTeam = this.handleSelectTeam.bind(this);
    this.queryDeleteTeam = this.queryDeleteTeam.bind(this);
    this.handleDeleteTeam = this.handleDeleteTeam.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);

  }

  componentDidMount() {
    const currentRole = dataModel.usersDAO.currentUser ? dataModel.usersDAO.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.teamsDataSource = new CollectionDataSource('TeamsCollection', 'Team', { team: { lead_user: {}, markets: {} } },
      this.handleTeamRetrieval, 'TeamsCollection', this.props.currentCompany.id);
    this.teamsDataSource.current();
  }

  componentWillUnmount() {
    if (this.teamsDataSource) {
      this.teamsDataSource.release();
      this.teamsDataSource = null;
    }
  }

  componentDidUpdate(){
    if(this.state.teams && this.state.teamsCopy && this.state.teams.ids.length > this.state.teamsCopy.ids.length){
      var newTeamsCopy = { ...this.state.teams, oldTeams: this.state.teams.teams };
      this.setState({ teamsCopy: newTeamsCopy  });
    }
  }

  handleTeamRetrieval(teams, action, acData, fetchedData) {

    if(!this.state.teamsCopy){
      var newTeamsCopy = { ...teams, oldTeams: teams.teams };
      this.setState({ teamsCopy: newTeamsCopy  });
    }
    
    this.setState({ loadingTeams: !(action != 'prefetch' || teams.teams.length > 0), teams });
  }

  handleSort() {
  }

  handleFilterChange(filter, dontSearch) {

    if (!filter && !this.state.searchString) {
      this.teamsDataSource = new CollectionDataSource('TeamsCollection', 'Team', { team: { lead_user: {}, markets: {} } },
        this.handleTeamRetrieval, 'TeamsCollection', this.props.currentCompany.id);
      this.teamsDataSource.current();
      this.setState({ filter });
      return;
    }
    if(filter) {
      if(!filter.hasOwnProperty('market')) filter.market = [];
      if(!filter.hasOwnProperty('lead')) filter.lead = [];

      const { teams, teamsCopy } = this.state;
      if(filter.lead.length == 0 && filter.market.length == 0) {
        this.teamsDataSource = new CollectionDataSource('TeamsCollection', 'Team', { team: { lead_user: {}, markets: {} } },
        this.handleTeamRetrieval, 'TeamsCollection', this.props.currentCompany.id);
        this.teamsDataSource.current();
        this.setState({ filter });
        return;
      }
      if(filter.lead.length != 0 && filter.market.length != 0) {
        var newTeamsUsers = teamsCopy.teams.filter(t => {
          return filter.lead.some(l => t.lead_id == l.id) && filter.market.some(m => t.markets.some(val=> val.id == m.id));
        });
        teams.teams = newTeamsUsers;
        teams.totalRecords = newTeamsUsers.length;
        this.setState({ filter, teams: teams, filteredTeams: { ...teams, filtersTeams: teams.teams } });
      }else if(filter.lead.length == 0 ||  filter.market.length == 0) {
        var newTeamsFilter = teamsCopy.teams.filter(t => {
          return filter.lead.some(l => t.lead_id == l.id)  ||  filter.market.some(m => t.markets.some(val=> val.id == m.id));
        });
        teams.teams = newTeamsFilter;
        teams.totalRecords = newTeamsFilter.length;
        this.setState({ filter, teams: teams, filteredTeams: { ...teams, filtersTeams: teams.teams }  });
      }
    }
    if(this.state.searchString && !filter) {
      const { teams,teamsCopy } = this.state;
      const newTeams = teamsCopy.teams.filter(team => team.name.toLowerCase().includes(this.state.searchString.toLowerCase()));
      teams.teams = newTeams;
      teams.totalRecords = newTeams.length;
      this.setState({ teams: teams });
    }
    if(this.state.searchString) {
      const { teams } = this.state;
      const newTeams = teams.teams.filter(team => team.name.toLowerCase().includes(this.state.searchString.toLowerCase()));
      teams.teams = newTeams;
      teams.totalRecords = newTeams.length;
      this.setState({ teams: teams, filter });

    }

    this.setState({ filter });

    // let dateRange = this.handleCreateDateRange(filter)

    // let height = Math.floor((window.innerHeight - 160) / 64)
    // this.props.referenceDocumentsDataModel.referenceDocuments = { clear: true }
    // let self = this
    // this.props.referenceDocumentsDataModel.fetchReferenceDocuments(this.state.searchString,
    //   filter && filter.documentType ? filter.documentType : "",
    //   filter && filter.market ? filter.market : "",
    //   dateRange,
    //   this.state.sortField,
    //   this.state.ascending,
    //   (referenceDocuments) => {
    //     self.setState({ filter, referenceDocuments })
    //   },
    //   height)
  }

  handleSearchChange(searchString) {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
    if (searchString) {
      const { filter, filteredTeams } = this.state;
     
      if(filter) {
        const { teams } = this.state;
        const newTeams = filteredTeams.filtersTeams.filter(team =>  team.name.toLowerCase().includes(searchString.toLowerCase()));
        teams.teams = newTeams;
        teams.totalRecords = newTeams.length;
        this.setState({ searchString, teams: teams });
      }else {
        const { teams, teamsCopy } = this.state;
        const newTeams = teamsCopy.teams.filter(team =>  team.name.toLowerCase().includes(searchString.toLowerCase()));
        teams.teams = newTeams;
        teams.totalRecords = newTeams.length;
        this.setState({ searchString, teams: teams });
      }

    } else {
      const { filter, filteredTeams } = this.state;
      if(filter) {
        filteredTeams.teams = filteredTeams.filtersTeams;
        filteredTeams.totalRecords = filteredTeams.filtersTeams.length;
        this.setState({ searchString, teams: filteredTeams });

      }else {
        setTimeout(() => {
          this.teamsDataSource = new CollectionDataSource('TeamsCollection', 'Team', { team: { lead_user: {}, markets: {} } },
            this.handleTeamRetrieval, 'TeamsCollection', this.props.currentCompany.id);
          this.teamsDataSource.current();
          this.setState({ searchString });
        }, 400);

      }

    }
  }

  handleAddButtonClicked(e) {
    e.stopPropagation();
    this.setState({ displayPopup: 'add_team' });
  }

  handleClosePopup() {
    this.setState({ displayPopup: false });
  }

  createPopup(type) {
    switch (type) {
    case 'add_team':
      return <TeamPopup currentCompany={this.props.currentCompany} currentUser={this.props.currentUser} handleClosePopup={this.handleClosePopup} />;
    case 'edit_team':
      return <TeamPopup teamId={this.state.selectedTeam ? this.state.selectedTeam.id : null} currentCompany={this.props.currentCompany} currentUser={this.props.currentUser} handleClosePopup={this.handleClosePopup} />;
    default:
      return null;
    }
  }

  handleSelectTeam(team) {
    this.analyticsLogger.logTeamEvent('TeamEdited');
    this.setState({ selectedTeam: team, displayPopup: 'edit_team' });
  }

  queryDeleteTeam(team) {

    dataModel.showGlobalModal('SYSTEM_POPUP', {
      cancelButtonText: this.textMap.cancel,
      okButtonText: 'YES',
      width: 300,
      height: 175,
      message: 'Are you sure you want to delete team ' + team.name + '? This action cannot be undone.',
      handleOwnerOk: () => {
        this.analyticsLogger.logTeamEvent('TeamDeleted');
        dataModel.teamsDAO.deleteTeam(team);
      },
    });
  }

  handleDeleteTeam(team) {
    this.queryDeleteTeam(team);
  }

  render() {
    const { teams, displayPopup } = this.state;
    const canAddTeam = this.props.permissions.isSuperUser || this.props.currentUser.role.name == 'admin';
    let teamContent = null;
    let teamCount = null;
    let popup = null;
    if (displayPopup) {
      popup = this.createPopup(displayPopup);
    }
    if (teams && teams.teams && teams.teams.length > 0) {
      teamCount = '(' + teams.teams.length + ' results)';

      teamContent = (
      
        <div className='teams-table'>
          <TeamsTable
            teams={this.state.teams}
            refresh={this.refresh}
            selectTeam={this.handleSelectTeam}
            filter={this.state.filter}
            loadingTeams={this.state.loadingTeams}
            searchString={this.state.searchString}
            sortField={this.state.sortField}
            ascending={this.state.ascending}
            handleSortChange={this.handleSortChange}
            getMoreTeams={this.handleGetMoreTeams}
            inProgress={this.state.loading}
            searching={this.state.searching}
            filterCleared={this.state.cleared}
            filterDisplayed={this.state.filterDisplayed}
            handleDeleteTeam={this.handleDeleteTeam}
          />

        </div>
      );
    }
    else {
      teamCount = '(0 results)';
      
      if (canAddTeam) {
        // let addTeamContent = null
        // addTeamContent = (
        //   <div className="teams-no-content__add">
        //     Select <img alt='button' className='teams-no-content__add-button' src={addIcon} onClick={this.handleAddButtonClicked} /> to get started!
        //   </div>
        // )
      }

      teamContent = (

       <div className="no-matches-indicator">No Teams Found...</div>
        // <div className='teams-no-content'>
        //   <img className='teams-no-content__icon' src={teamIcon} alt='Teams' />
        //   <div className="teams-no-content__text">No Teams have been created.</div>
        //   {addTeamContent}
        // </div>
      );
    }

    let directoryTeamsSearchFilter = <DirectoryTeamsSearchFilter searchString={this.state.searchString} handleFilterChange={this.handleFilterChange} handleSearchChange={this.handleSearchChange} selectedFilters={this.state.filter} />;
    return (
      <div className='teams'>
        <ReportHeader
          reportTitle={'Teams'}
          minWidth={200}
          hideExport={true}
        >
          <div className='teams-header-item-count'>
            <div className='teams-header-item-text-count'>{teamCount}</div>
          </div>
          {canAddTeam &&
            <div className='teams-header-item' onClick={this.handleAddButtonClicked}>
              <img src={addIcon} alt="Add New Team" onClick={this.handleAddButtonClicked} />
              <div className='teams-header-item-text'>Add New Team</div>
            </div>
          }

          <div className="directory-search">
            {directoryTeamsSearchFilter}
          </div>

        </ReportHeader>
        {popup}
        {teamContent}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(Teams);



// WEBPACK FOOTER //
// ./src/containers/Directory/Teams/index.js